/**
 * Per-event kiosk passwords: POST/GET/DELETE /planning/:project_id/events/:event_id/kiosk-credentials (owner and admin only).
 * The password is in the create answer ONCE; the list never carries it.
 */
import { apiDelete, apiGet, apiPost, planningPath } from './PlanningApiClient';

export interface KioskPassword {
  id: string;
  event_id: string;
  label: string;
  created_at: string;
  expires_at: string | null;
  revoked_at: string | null;
  last_used_at: string | null;
}

export type KioskPasswordState = 'active' | 'revoked' | 'expired';

export const kioskPasswordState = (p: KioskPassword, now: number = Date.now()): KioskPasswordState => {
  if (p.revoked_at) return 'revoked';
  if (p.expires_at && Date.parse(p.expires_at) <= now) return 'expired';
  return 'active';
};

const base = (eventId: string): string => planningPath(`/events/${encodeURIComponent(eventId)}/kiosk-credentials`);

export async function listKioskPasswords(eventId: string): Promise<KioskPassword[]> {
  return (await apiGet<{ credentials: KioskPassword[] }>(base(eventId))).credentials;
}

export async function createKioskPassword(eventId: string, input: { label: string; expires_at?: string }): Promise<KioskPassword & { password: string }> {
  return apiPost(base(eventId), input);
}

export async function revokeKioskPassword(eventId: string, id: string): Promise<void> {
  await apiDelete(`${base(eventId)}/${encodeURIComponent(id)}`);
}

/** The link a door device opens for this event. */
export const kioskLinkFor = (eventId: string, origin: string = window.location.origin): string =>
  `${origin}/kiosk?event=${encodeURIComponent(eventId)}`;
